// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"317":"a704ebe0","679":"618256a7","713":"13a38a80","979":"c53ec6cd"}[chunkId] + ".js";
};